import styled from '@emotion/styled';
import mediaQuery from '@/lib/styling/mediaQuery';

const ChallengeContentWrapper = styled('section')({
  padding: '24px 48px',
  [mediaQuery(560)]: {
    padding: 24,
  },
});

export default ChallengeContentWrapper;
